import React, { Component } from 'react';
import AmCharts from "@amcharts/amcharts3-react";
import styled from 'styled-components';

const Ohlcdiv = styled.div`
  width: 50%;
  height: 300px;
`;

export default class OHLC extends Component {

  componentDidMount() {
    const { history } = this.props;
    console.log('Histrory: ', history)
    let chart = AmCharts.makeChart(this.ohlcDiv, {
      "type": "stock",
      "theme": "none",

      "dataSets": [ {
        "title": "open",
        "fieldMappings": [ {
          "fromField": "open",
          "toField": "open"
        }, {
          "fromField": "close",
          "toField": "close"
        }, {
          "fromField": "high",
          "toField": "high"
        }, {
          "fromField": "low",
          "toField": "low"
        } ],
        "color": "#509dde",
        "dataProvider": history,
        "categoryField": "trading_date"
      } ],

      "categoryAxesSettings": {
        "inside": false,
        "showLastLabel": true,
        "showFirstLabel": true,
        "gridColor": '#ffffff',
      },

      "valueAxesSettings": {
        "unit": "$",
        "unitPosition": "left",
        "inside": false,
        "showLastLabel": true,
        "showFirstLabel": false,
        "gridColor": '#ffffff',
      },
      "panelsSettings": {
        "marginLeft": 50,
        "marginTop": 20,
        "marginRight": 10,
        "panelSpacing": 0,
        "usePrefixes": true,
        "prefixesOfBigNumbers":[{number:1e+3,prefix:"K"},
                                {number:1e+6,prefix:"M"},
                                {number:1e+9,prefix:"B"},
                                {number:1e+12,prefix:"T"},
                                {number:1e+15,prefix:"P"},
                                {number:1e+18,prefix:"E"},
                                {number:1e+21,prefix:"Z"},
                                {number:1e+24,prefix:"Y"}],
      },

      "panels": [ {
        "showCategoryAxis": true,
        "title": "Value",
        "color": "white",

        "stockGraphs": [ {
          "type": "candlestick",
          "id": "g1",
          "openField": "open",
          "closeField": "close",
          "highField": "high",
          "lowField": "low",
          "valueField": "close",
          "lineColor": "#7f8da9",
          "fillColors": "#7f8da9",
          "negativeLineColor": "#db4c3c",
          "negativeFillColors": "#db4c3c",
          "fillAlphas": 1,
          "useDataSetColors": false,
          "proCandlesticks": true
        } ],
      },
    ],

      "chartScrollbarSettings": {
        "enabled": false,
      },

      "periodSelector": {
        "position": "bottom",
        "dateFormat": "DD MM, YYYY",
        "inputFieldsEnabled": false,
        "periods": [ {
          "period": "DD",
          "count": 14,
          "label": "14 Days"
        }, {
          "period": "MM",
          "count": 1,
          "label": "1 Month"
        }, {
          "period": "MM",
          "count": 3,
          "label": "3 Months"
        }, {
          "period": "YYYY",
          "count": 1,
          "label": "1 Year"
        }, {
          "period": "MAX",
          "selected": true,
          "label": "All"
        }]
      },

      "export": {
        "enabled": false
      }
    });

    this.chart = chart;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {

    if (nextProps.history.length) {
      const { history } = nextProps;
      console.log('H: ', history)
      this.chart.dataSets[0].dataProvider = history;
      this.chart.validateData();
    }
  }

  render() {
    return <Ohlcdiv><div className="ohlcDiv" style={{height: '100%'}} ref={(ref) => this.ohlcDiv = ref} /></Ohlcdiv>
  }
}



// WEBPACK FOOTER //
// ./src/main/content/company/components/OHLC.js